import React, { Component } from 'react';
import './Validation.css';

export default class Validation extends Component {
	render() {
		return <div className="g-validation">required</div>;
	}
}
